import store from "../store";
import http from "../http-common";

// Resolve display names once per result set; IDs remain unchanged for routing.
async function withUsernames(request) {
  const response = await request;
  const value = response.data;
  const items = Array.isArray(value) ? value : (value && Array.isArray(value.items) ? value.items : [value]);
  if (!items.some(item => item && item.userId)) return response;
  try {
    const users = await http.get("/users");
    const names = new Map(users.data.map(user => [user.userId, user.username || user.userId]));
    items.forEach(item => {
      if (item && item.userId) item.username = names.get(item.userId) || item.userId;
    });
  } catch (_) {
    // Keep the assignment accessible if the name lookup fails.
  }
  return response;
}

http.interceptors.request.use(function (config) {
  config.headers.token = store.getters.token;
  return config;
});

class AssignmentDataService {
  getPage(params) { return withUsernames(http.get("/admin/assignments", { params })); }
  getAll() {
    return withUsernames(http.get("/assignments"));
  }

  getSortedAndFiltered(sortBy, from, to) {
    return withUsernames(http.get(`/assignments/sorted/${sortBy}/filtered/${from}/${to}`));
  }

  getAssignment(id) {
    return withUsernames(http.get(`/assignments/${id}`));
  }

  getAssignmentsOfSurvey(id) {
    return withUsernames(http.get(`/surveys/${id}/assignments`));
  }

  getAssignmentsOfUser(id) {
    return withUsernames(http.get(`/users/${id}/allassignments`));
  }

  getAssignmentsOfGroup(id) {
    return withUsernames(http.get(`/groups/${id}/assignments`));
  }

  search(inputText) {
    return withUsernames(http.get(`/assignments/search/?t=${inputText}`));
  }
}

export default new AssignmentDataService();